import { Avatar, Box, Typography } from "@mui/material";
import { Premium, Neutrals, Primary } from "../../../core-components/theme/color-palette/colors";
import DrPaani from "../../../core-components/assets/icons/DrPaani";
import { formatCommunicationTimestamp, getCommIcon } from "../../CommunicationPopper/helpers/helper";


const getAvatar = (user: { name: string; image?: string }) => {
    if (user.name === 'DOCTOR_PAANI') {
      return (
        <Box sx={{ width: 48, height: 48, borderRadius: '50%', bgcolor: 'white', overflow: 'hidden', border: '2px solid', borderColor: Premium[700], display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, alignSelf: 'flex-end', mt: 2 }}>
          <DrPaani width={48} height={48} />
        </Box>
      );
    } else if (user.image) {
      return <Avatar src={user.image} sx={{ width: 48, height: 48, borderRadius: '50%', flexShrink: 0, alignSelf: 'flex-end', mt: 2 }} />;
    } else if (user.name) {
      const parts = user.name.split(' ');
      const initials = parts.length === 1 ? parts[0][0].toUpperCase() : (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      return <Avatar sx={{ width: 48, height: 48, bgcolor: Primary[900], color: '#fff', fontWeight: 700, flexShrink: 0, alignSelf: 'flex-end', mt: 2 }}>{initials}</Avatar>;
    } else {
      return <Avatar sx={{ width: 48, height: 48, flexShrink: 0, alignSelf: 'flex-end', mt: 2 }}>?</Avatar>;
    }
  };

const MessageBubble = ({ message, isLeft, user, oneSideConversation = false }: any) => {
    return (
    <Box sx={{
      display: 'flex',
      flexDirection: isLeft ? 'row' : 'row-reverse',
      alignItems: 'flex-end',
      mb: 3,  
      gap: 2,
    }}>
      {getAvatar(user)}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: isLeft ? 'flex-start' : 'flex-end' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb:oneSideConversation ? 1 : 0.5 }}>
          <Typography variant="caption" sx={{ fontWeight: 600, fontSize: "12px", color: Neutrals[500] }}>{message.messageHeader}</Typography>
          <Typography variant='caption' sx={{ mx: 1, fontWeight: "bold", fontSize: "12px", color: Neutrals[300] }}>•</Typography>
          <Typography variant="caption" sx={{ color: Neutrals[300] }}>{formatCommunicationTimestamp(message?.timestamp)}</Typography>
          {oneSideConversation && message.channel && (
            <>
          <Typography variant='caption' sx={{ mx: 1, fontWeight: "bold", fontSize: "12px", color: Neutrals[300] }}>•</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "16px", height: "16px", borderRadius: '50%', bgcolor: Premium[200], color: Premium[700] }}>
              {getCommIcon(message.channel)}
            </Box>
            </>
          )}
        </Box>
        <Box sx={{
          maxWidth: oneSideConversation ? '100%' : '70%',
          bgcolor: isLeft ? '#FAFAFA' : Neutrals[50],
          color: '#183650',
          borderRadius: 3,
          border: "1px solid",
          borderColor: message.senderType === 'DOCTOR_PAANI' ? Premium[200] : isLeft ? 'lightgrey' : Neutrals[50],
          borderBottomLeftRadius: isLeft ? 0 : 12,
          borderBottomRightRadius: isLeft ? 12 : 0,
          p: 2,
          position: 'relative',
          boxShadow: 0,
        }}>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-line', wordBreak: 'break-word', color: Neutrals[500] }}>{message.messageContent}</Typography>
        </Box>
      </Box>
    </Box>
  )};

export default MessageBubble;